import React,{useContext, useState} from 'react'
import remained_itemaction from '../../context/action/remained_item/remained_itemaction';
import { GlobalContext } from "../../context/provider";
import Remained_itemlist from './remained_itemlist';

const Remained_item = () => {
    const {clear}=useContext(GlobalContext);

    const [items,setitems]=useState([]);
    const [total_6_to_9_months,settotal_6_to_9_months]=useState(0);
    const [total_more_than_9_months,settotal_more_than_9_months]=useState(0);

    return (
        <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-slate-50">
            <div className="w-full h-16 sm:h-20 lg:h-24 flex justify-center items-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-4 sm:mb-6">
                    وردەکاری کاڵای ماوە بۆ ماوەیەکی درێژ
            </div>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div 
                    className="flex justify-center items-center cursor-pointer w-full rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" 
                    onClick={()=>{
                        remained_itemaction(6)(clear)(setitems)(settotal_6_to_9_months)(settotal_more_than_9_months);
                    }}
                >
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        ڕاکێشانی ڕاپۆڕت
                    </h5>
                </div>
            </div>
            {items?.length>0?
                <Remained_itemlist items={items} total_6_to_9_months={total_6_to_9_months} total_more_than_9_months={total_more_than_9_months} />:
            null}
        </div>
    )
}

export default Remained_item